export default __webpack_public_path__ + "static/media/purple.9bc80e6d.ogg";